import { useContext } from 'react';
import { UserContext } from '@/context/userContext';
import { isUserInGroup } from '@/auth/EricksonAuthenticator';
import { FILE_MANAGER_PERMISSIONS } from '@/constants/FileManagerConstants';

import { User } from '@/types/user';

interface UseFileManagerAuthReturn {
  user: User | null;
  isAuthenticated: boolean;
  isAuthorized: boolean;
  isLoading: boolean;
}

/**
 * Custom hook for file manager authentication and authorization checks.
 * Centralizes the logic for determining if a user can access the file manager.
 */
export const useFileManagerAuth = (): UseFileManagerAuthReturn => {
  const userContext = useContext(UserContext);

  const isAuthenticated = userContext.isAuthenticated === true;
  const isLoading = userContext.isAuthenticated === null;

  const isAuthorized =
    isAuthenticated &&
    userContext.user !== null &&
    isUserInGroup(userContext.user, FILE_MANAGER_PERMISSIONS.ALLOWED_GROUPS) &&
    userContext.user.hasFileManagerAccess;

  return {
    user: userContext.user,
    isAuthenticated,
    isAuthorized,
    isLoading,
  };
};
